/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
import { useExtensions } from '@adobe/uix-host-react'
import { UixFrame } from './utils'
import { PageAppProps } from './props/PageAppProps'

export const MenuPage = ({ extensionId }: PageAppProps) => {
  const { extensions } = useExtensions(() => ({
    updateOn: 'all',
    provides: {
      integration: {
        getCommerceHost() {
          return window.location.host
        }
      }
    }
  }))

  const extension = extensions.find((item) => item.id === extensionId)
  if (!extension) {
    return <></>
  }

  return (
    <UixFrame
      url={`${extension.url.origin}/index.html`}
      extensionId={extension.id}
      redirectUrl={''}
    />
  )
}
